import styles from "@/components/popup-shell.module.css";
import { Dialog } from "@headlessui/react";
import clsx from "clsx";
import { JSX, ReactNode } from "react";

interface PopupShellProps {
	children: ReactNode;
	className?: string;
	isClosing: boolean;
	isOpen: boolean;
	onClose?: () => void | Promise<void>;
}

function PopupShell({
	children,
	className,
	isClosing,
	isOpen,
	onClose,
}: PopupShellProps): JSX.Element {
	const handleClose = (): void => {
		void onClose?.();
	};

	return (
		<Dialog
			onClose={handleClose}
			open={isOpen}
		>
			<div
				className={clsx(
					"overlay",
					!isClosing && "zoom-in",
					(isClosing || !isOpen) && "zoom-out",
				)}
			>
				<div
					className={clsx(styles["popup"], className)}
					role="dialog"
				>
					{children}
				</div>
			</div>
		</Dialog>
	);
}

export default PopupShell;
